angular.module('zc.commonApi')
  .factory('CampaignConversionData', campaignConversionDataFactory);

function campaignConversionDataFactory(FacadeV2) {
  return class CampaignConversionData {
    static find(paths, params) {
      return FacadeV2.request(`/apikeys/${paths.apikey}/campaign_conversion_data/find`, {params}).then(res => res.data);
    }
  };
}
campaignConversionDataFactory.$inject = ['FacadeV2'];



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/facade/campaign_conversion_data.service.js